import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["onClick"]

import { withDefaults } from 'vue'

type ComponentProperties = {
  isPlayNow?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PlayPreviewButton',
  props: {
    isPlayNow: { type: Boolean, default: false }
  },
  emits: ['start-play', 'stop-play'],
  setup(__props: any, { emit }) {

const props = __props as { isPlayNow: boolean };





const handleClick = () => {
  if (!props.isPlayNow) {
    emit('start-play')
  } else {
    emit('stop-play')
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    onClick: _withModifiers(handleClick, ["prevent","stop"])
  }, [
    (props.isPlayNow)
      ? _renderSlot(_ctx.$slots, "stop", { key: 0 })
      : _renderSlot(_ctx.$slots, "play", { key: 1 })
  ], 8, _hoisted_1))
}
}

})